/**
 * Chatbot API service for Impact Plexus Copilot
 */
import apiClient from '../lib/apiClient';

export const sendChatMessage = async ({ message, sessionId, charityBN }) => {
  const response = await apiClient.post('/chatbot/chat', {
    message,
    session_id: sessionId || undefined,
    charity_bn: charityBN || undefined,
  }, { timeout: 60000 });
  return response.data;
};

export const streamChatMessage = async ({ message, sessionId, charityBN, onChunk, onDone, onError }) => {
  const body = JSON.stringify({
    message,
    session_id: sessionId || undefined,
    charity_bn: charityBN || undefined,
    stream: true,
  });

  const apiBase = process.env.REACT_APP_API_URL || '/api';

  try {
    const resp = await fetch(`${apiBase}/chatbot/chat/stream`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` },
      body,
    });

    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        try {
          const data = JSON.parse(line.slice(6));
          if (data.text) onChunk?.(data.text, data.session_id);
          if (data.done) onDone?.(data.session_id);
          if (data.error) onError?.(data.error);
        } catch {
          // skip malformed chunks
        }
      }
    }
  } catch (err) {
    onError?.(err.message || 'Connection failed');
  }
};

export const clearChatSession = async (sessionId) => {
  const response = await apiClient.delete(`/chatbot/chat/${sessionId}`);
  return response.data;
};

export const getChatbotHealth = async () => {
  const response = await apiClient.get('/chatbot/chat/health');
  return response.data;
};
